import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QUIZ_FEATURE_KEY } from './keys';
import { quizReducer } from './reducers/quiz.reducer';
import { QuizEffects } from './effects/quiz.effects';

export function provideQuizStore(): EnvironmentProviders[] {
    return [provideState(QUIZ_FEATURE_KEY, quizReducer), provideEffects(QuizEffects)];
}
